module.exports = __webpack_public_path__ + "static/media/ky.93a85a55.svg";